import React from 'react';
import { useInstitucion } from '../context/InstitucionContext';
import MarcaPusah from './MarcaPusah';

// Pie de las páginas públicas: línea de la institución y la marca de la plataforma.
const Footer = () => {
  const { institucion, nombreMarca } = useInstitucion();
  const anio = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-gray-400">
        <p className="text-center sm:text-left">
          © {anio} {institucion ? institucion.nombre : nombreMarca} — Centro de Publicaciones
        </p>
        <p className="flex items-center gap-2">
          <span>Impulsado por</span>
          <MarcaPusah className="h-5" />
        </p>
      </div>
    </footer>
  );
};

export default Footer;
